/* eslint-disable react/no-unstable-nested-components */
import { Box, Grid, InputLabel, MenuItem, Select, FormControlLabel } from '@mui/material';
import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import GroupSubOption from './GroupSubOption';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { CommonStyles } from '../CommonStyles';
import { MANDATORY_FIELD_ERR } from '../../../constants';
import { businessMapping } from '../../../services/businessMapping';
import { productTypeMapping } from '../../../services/productTypeMapping';
import { commonTernary, isBundle } from '../../commonCode';
import { DownArrowIcon } from '../../../images/svg/CustomizedSVG';
import { productMapping } from '../../../services/productMapping';

function GroupOption({ setItemsAnswer, parent, component, question, itemsAnswer }) {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { productName, theme, currentPage } = leadGenerationContext;
  const commonClasses = CommonStyles(theme);
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  const { t } = useTranslation();
  const [translation, setTranslation] = useState(leadGenerationContext.productQuestionsEN);
  useEffect(() => {
    if (leadGenerationContext.language === 'EN') {
      setTranslation(leadGenerationContext.productQuestionsEN);
    }
    if (leadGenerationContext.language === 'ES') {
      setTranslation(leadGenerationContext.productQuestionsES);
    }
  }, [leadGenerationContext.language]);

  const selectValueFunction = (label2, option) => {
    let newVal;
    if (label2) {
      newVal = label2;
    } else {
      newVal = option;
    }
    return newVal;
  };
  useEffect(() => {
    const label1 = `${question.name}_${component.label}`;
    if (component?.options?.length > 0) {
      let selectedValue;

      if (
        isBundle(productName) &&
        leadGenerationContext.productTabVal === 0 &&
        !leadGenerationContext.productAccountType
      ) {
        selectedValue = selectValueFunction(
          leadGenerationContext.formAnswerSavings[label1],
          component?.options[0]
        );
      } else if (
        (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
        !isBundle(productName) ||
        leadGenerationContext.productAccountType
      ) {
        selectedValue = selectValueFunction(
          leadGenerationContext.formAnswer[label1],
          component?.options[0]
        );
      }

      if (selectedValue === component?.options[0]) {
        if (
          isBundle(productName) &&
          leadGenerationContext.productTabVal === 0 &&
          !leadGenerationContext.productAccountType
        ) {
          leadGenerationContext.setFormAnswerSavings({
            ...leadGenerationContext.formAnswerSavings,
            [label1]: component?.options[0],
          });
        } else if (
          (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
          !isBundle(productName) ||
          leadGenerationContext.productAccountType
        ) {
          leadGenerationContext.setFormAnswer({
            ...leadGenerationContext.formAnswer,
            [label1]: component?.options[0],
          });
        }
      }
    }
  }, []);

  const onHandleChange = (event) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    leadGenerationContext.setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFeatureScreenDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);

    if (question.type !== 'IRA') {
      if (
        isBundle(productName) &&
        leadGenerationContext.productTabVal === 0 &&
        !leadGenerationContext.productAccountType
      ) {
        leadGenerationContext.setFormAnswerSavings({
          ...leadGenerationContext.formAnswerSavings,
          [event.target.name]: event.target.value,
        });
      } else if (
        (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
        !isBundle(productName) ||
        leadGenerationContext.productAccountType
      ) {
        leadGenerationContext.setFormAnswer({
          ...leadGenerationContext.formAnswer,
          [event.target.name]: event.target.value,
        });
      }
    } else {
      setItemsAnswer({ ...itemsAnswer, [question.name]: event.target.value });
    }
  };

  const onHandleChangeCheckbox = (event) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    leadGenerationContext.setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);

    if (
      isBundle(productName) &&
      leadGenerationContext.productTabVal === 0 &&
      !leadGenerationContext.productAccountType
    ) {
      leadGenerationContext.setFormAnswerSavings({
        ...leadGenerationContext.formAnswerSavings,
        [event.target.name]: event.target.checked,
      });
    } else if (
      (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
      !isBundle(productName) ||
      leadGenerationContext.productAccountType
    ) {
      leadGenerationContext.setFormAnswer({
        ...leadGenerationContext.formAnswer,
        [event.target.name]: event.target.checked,
      });
    }
  };

  const onHandleKeyPressCheckbox = (name, value) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    leadGenerationContext.setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);

    if (
      isBundle(productName) &&
      leadGenerationContext.productTabVal === 0 &&
      !leadGenerationContext.productAccountType
    ) {
      leadGenerationContext.setFormAnswerSavings({
        ...leadGenerationContext.formAnswerSavings,
        [name]: value,
      });
    } else if (
      (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
      !isBundle(productName) ||
      leadGenerationContext.productAccountType
    ) {
      leadGenerationContext.setFormAnswer({
        ...leadGenerationContext.formAnswer,
        [name]: value,
      });
    }
  };
  const questionType = (a, b) => {
    let type;
    if (question.type === 'IRA') {
      type = a;
    } else {
      type = b;
    }
    return type;
  };

  const isChecked = () => {
    if (
      isBundle(productName) &&
      leadGenerationContext.productTabVal === 0 &&
      !leadGenerationContext.productAccountType
    ) {
      return leadGenerationContext.formAnswerSavings[label];
    }
    if (
      (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
      !isBundle(productName) ||
      leadGenerationContext.productAccountType
    ) {
      return leadGenerationContext.formAnswer[label];
    }
  };
  const label = `${question.name}_${component.label}`;
  switch (component.type) {
    case 'image':
      return (
        <Grid>
          <img src={component.src} alt={component.label} />
        </Grid>
      );
    case 'select': {
      let selectedValue = '';
      let id = '';
      if (parent) {
        id = `${parent}_${question.name}_${component.label}`;
      } else {
        id = `${question.name}_${component.label}`;
      }
      if (question.type !== 'IRA') {
        if (
          isBundle(productName) &&
          leadGenerationContext.productTabVal === 0 &&
          !leadGenerationContext.productAccountType
        ) {
          selectedValue = selectValueFunction(
            leadGenerationContext.formAnswerSavings[label],
            component?.options[0]
          );
        } else if (
          (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
          !isBundle(productName) ||
          leadGenerationContext.productAccountType
        ) {
          selectedValue = selectValueFunction(
            leadGenerationContext?.formAnswer?.[label],
            component?.options[0]
          );
        }
      } else {
        selectedValue = selectValueFunction(itemsAnswer[question.name], component?.options[0]);
      }

      const setSelectedValueStyle = (a, b) => {
        let data;
        if (
          !selectedValue ||
          selectedValue === 'Select...' ||
          selectedValue === 'Select Withdraw $' ||
          selectedValue === 'Select Deposits $'
        ) {
          data = a;
        } else {
          data = b;
        }
        return data;
      };
      const isCdira = productMapping(productName) === 'CD IRA';
      return (
        <Grid
          size={{
            xs: 12,
            md: isCdira ? 12 : questionType(4, 6),
            sm: isCdira ? 12 : questionType(6, 12),
            lg: isCdira ? 12 : questionType(4, 6),
          }}
          sx={
            question.type === 'IRA'
              ? styledClasses.ira_group_sub_select
              : commonTernary(
                  isBundle(productName),
                  {
                    padding: '10px 20px 0',
                    '@media (max-width:600px)': {
                      padding: '0px',
                    },
                  },
                  styledClasses.group_sub_select
                )
          }
        >
          <InputLabel
            required={!isBundle(productName)}
            id={`${id}_label`}
            sx={styledClasses.label_title}
            aria-label={translation[component.label]}
          >
            {translation[component.label]}
          </InputLabel>
          <Select
            fullWidth
            variant="outlined"
            id={id}
            data-testid="select_testid"
            name={label}
            IconComponent={() => (
              <Box
                sx={{
                  padding: currentPage === 'product-info' ? '0 20px 0 0' : '0 10px 0 0',
                }}
              >
                <DownArrowIcon
                  style={{ width: 24, height: 24 }}
                  color={theme?.palette?.orientalPrimary?.main}
                />
              </Box>
            )}
            aria-label={`${translation[component.label]} ${t(
              'Required Select dropdown menu button',
              { defaultValue: 'Required Select dropdown menu button' }
            )}`}
            role="listbox"
            defaultValue={component?.options[0]}
            value={selectedValue}
            MenuProps={{
              disableScrollLock: true,
              PaperProps: {
                sx: {
                  ...theme?.menuBackground,
                  border: `1px solid ${theme?.menuBackground?.borderColor} !important`,
                  color: theme?.palette?.primary?.main,
                },
                className: isBundle(productName) ? 'bundle-menu-paper' : '',
              },
            }}
            slotProps={{
              icon: {
                sx: styledClasses.select_icon,
              },
              select: {
                sx: setSelectedValueStyle(
                  styledClasses.select_inputs_placeholder,
                  styledClasses.select_style
                ),
              },
              notchedOutline: {
                sx: isBundle(productName)
                  ? [
                      {
                        ...commonClasses.customBorderRadius,
                        border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                      },
                    ]
                  : [],
              },
            }}
            sx={{
              ...(question.type !== 'IRA'
                ? styledClasses.group_sub_select_width
                : styledClasses.IRA_select_width),
              color:
                selectedValue === 'Select Deposits $' || selectedValue === 'Select Withdraw $'
                  ? theme?.palette?.fieldsPlaceholder?.main
                  : theme?.palette?.primary?.main,
            }}
            onChange={onHandleChange}
            autoFocus={question.type === 'IRA'}
          >
            {component.options.map((item) => (
              <MenuItem
                sx={{
                  color:
                    item === 'Select Deposits $' || item === 'Select Withdraw $'
                      ? theme?.palette?.fieldsPlaceholder?.main
                      : theme?.palette?.primary?.main,
                }}
                key={item}
                value={item}
                aria-label={t(translation[item] ? translation[item] : item, {
                  defaultValue: translation[item] ? translation[item] : item,
                })}
              >
                {t(translation[item] ? translation[item] : item, {
                  defaultValue: translation[item] ? translation[item] : item,
                })}
              </MenuItem>
            ))}
          </Select>
          <Box
            component="span"
            style={{ display: 'none' }}
            id={`${id}_errorSpan`}
            sx={styledClasses.error_message_product}
            role="alert"
          >
            {t(MANDATORY_FIELD_ERR, { defaultValue: MANDATORY_FIELD_ERR })}
          </Box>
        </Grid>
      );
    }
    case 'checkbox':
      return (
        <Grid size={{ xs: 12 }}>
          <FormControlLabel
            control={
              <div>
                <label className="checkbox-label">
                  <input
                    tabIndex="0"
                    type="checkbox"
                    data-testid="checkbox_testid"
                    aria-label={translation[component.label]}
                    checked={isChecked() ? isChecked() : false}
                    onChange={onHandleChangeCheckbox}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        onHandleKeyPressCheckbox(label, !isChecked());
                      }
                    }}
                    name={label}
                  />
                  <span style={{ marginLeft: '2px' }} className="checkbox-custom rectangular" />
                </label>
              </div>
            }
            id={`${parent}_${question.name}_${component.label}_label`}
            label={translation[component.label]}
          />

          {component.subComponents && isChecked() && (
            <div style={{ marginLeft: '30px' }}>
              <Grid container size={{ xs: 12 }}>
                <GroupSubOption parent={parent} question={question} component={component} />
              </Grid>
            </div>
          )}
        </Grid>
      );
    default:
  }
}

GroupOption.propTypes = {
  setItemsAnswer: PropTypes.func,
  parent: PropTypes.string,
  component: PropTypes.object,
  question: PropTypes.object,
  itemsAnswer: PropTypes.object,
};
export default GroupOption;
